

































































import Component from "vue-class-component";
import VueForm from './form.vue';
import VueMetadata from './metadata.vue';
import VueProgressBar from "@/components/progress-bar.vue";
import { default as mixins } from '../mixins/user';
import VueTags from "@/components/tags.vue";
import { mapActions, mapGetters, mapState } from 'vuex';
import { Mixins } from "vue-property-decorator";
import { GuideMixin } from '@/components/mixins/guide';

@Component({
  mixins: [ mixins ],
  components: {
    'vue-tags': VueTags,
    'vue-form': VueForm,
    'vue-metadata': VueMetadata,
    'vue-progress-bar': VueProgressBar
  },
  computed: {
    ...mapGetters('user', ['isAuthorized']),
    ...mapState('guides', ['guide'])
  },
  methods: {
    ...mapActions('guides', ['vote', 'subscribe'])
  }
})
export default class VuePost extends Mixins(GuideMixin) {
  private isShowing = false;

  edit() {
    this.$store.commit('guides/EDIT');
  }

  setRole(value: number) {
    const role = Object.keys(this.roles)[value - 1]

    this.$store.dispatch('guides/setRole', { guide: this.guide, role });
  }

  deleteItem() {
    this.$confirm({
      message: 'Tej operacji nie będzie można cofnąć.',
      title: 'Usunąć wpis?',
      okLabel: 'Tak, usuń'
    })
    .then(() => this.$store.dispatch('guides/delete', this.guide))
    .then(() => window.location.href = '/Guide');
  }
}
